export const EXTENSION_URL = 'https://vitall.com/documentation/extensions/';
export const VITALL_SYSTEM = 'https://vitall.com/documentation';

export const APPOINTMENTS_DIAGNOSIS = 'appointments/diagnosis';
export const APPOINTMENTS_YEAR = 'appointments/appointment-year';
export const APPOINTMENTS_SHOW_VISIT_TIME = 'appointments/show-time';

export const CONDITION_CODES = 'medical-conditions/ext-codes';

export const EXTENSIONS_NOTES = 'notes';
export const EXTENSIONS_RECORD_SOURCE = 'record-source';
export const EXTENSIONS_SELF_REPORTED = 'self-reported';
export const EXTENSIONS_ASSOCIATED_RECORDS = 'associated-records';
export const EXTENSIONS_ATTACHMENTS = 'attachments';

export const EMERGENCY_VISIT_NOTES = 'emergency-visits/notes';

export const FAMILY_HISTORY_MATERNAL_PATERNAL =
  'family-history/maternal-paternal';

export const HOSPITALIZATIONS_FOLLOW_UP = 'hospitalizations/follow-up';
export const HOSPITALIZATIONS_COMPLICATIONS = 'hospitalizations/complications';

export const IMAGING_AND_TESTS_TEST_NAME = 'imaging-and-tests/test-name';
export const IMAGING_AND_TESTS_REPORTED_DATE =
  'imaging-and-tests/reported-date';
export const IMAGING_AND_TESTS_HISTORY = 'imaging-and-tests/history';
export const IMAGING_AND_TESTS_TECHNIQUE = 'imaging-and-tests/technique';
export const IMAGING_AND_TESTS_FINDINGS = 'imaging-and-tests/findings';
export const IMAGING_AND_TESTS_RECOMMENDATIONS =
  'imaging-and-tests/recommendations';
export const IMAGING_AND_TESTS_AVAILABLE_IMAGES =
  'imaging-and-tests/available-images';

export const INSURANCE_PROGRAMS_ENROLLMENT_CODE =
  'insurance-programs/enrollment-code';
export const INSURANCE_PROGRAMS_COUNTRY = 'insurance-programs/country';
export const INSURANCE_PROGRAMS_ADDITIONAL_INFORMATION =
  'insurance-programs/additional-information';
export const INSURANCE_PROGRAMS_PLAN_IDENTIFIER =
  'insurance-programs/plan-identifier';

export const LAB_REPORT_TEST_NAME = 'lab-report/test-name';

export const MEDICATIONS_DOSE = 'medications/dose';
export const MEDICATIONS_FREQUENCY = 'medications/frequency';

export const PATIENTS_GENDER = 'patients/gender';

export const PROCEDURES_PREOPERATIVE_DIAGNOSIS =
  'procedures/preoperative-diagnosis';
export const PROCEDURES_POST_OPERATIVE_DIAGNOSIS =
  'procedures/post-operative-diagnosis';
export const PROCEDURES_STATUS = 'procedures/status';
export const PROCEDURES_ELB = 'procedures/elb';
export const PROCEDURES_PLAN = 'procedures/plan';

export const RELATED_PERSON_ASSOCIATION = 'related-person/association';

export const ROUTINES_RECURRENCE_JAN = 'routines/recurrence-january';
export const ROUTINES_RECURRENCE_FEB = 'routines/recurrence-february';
export const ROUTINES_RECURRENCE_MAR = 'routines/recurrence-march';
export const ROUTINES_RECURRENCE_APR = 'routines/recurrence-april';
export const ROUTINES_RECURRENCE_JUN = 'routines/recurrence-may';
export const ROUTINES_RECURRENCE_JUL = 'routines/recurrence-june';
export const ROUTINES_RECURRENCE_AUG = 'routines/recurrence-july';
export const ROUTINES_RECURRENCE_SEP = 'routines/recurrence-august';
export const ROUTINES_RECURRENCE_OCT = 'routines/recurrence-october';
export const ROUTINES_RECURRENCE_NOV = 'routines/recurrence-november';
export const ROUTINES_RECURRENCE_DEC = 'routines/recurrence-december';
export const ROUTINES_RECURRENCE_MONTHDAY = 'routines/recurrence-monthday';
export const ROUTINES_RECURRENCE_EXDATE = 'routines/recurrence-exdate';
export const ROUTINES_RECURRENCE_NTHWEEKDAY = 'routines/recurrence-nthweekday';

export const VITAL_SIGNS_DEVICES_SOURCE = 'vital-signs/devices/source';
export const VITAL_SIGNS_DEVICES_INTERVAL = 'vital-signs/devices/interval';

export const VITAL_SIGNS_CLINICAL_NON_CLINICAL =
  'vital-signs/clinical-non-clinical';
